import * as React from 'preact/compat'
import BackButton from '../BackButton'
import type { DialogComponentPropTypes } from "../AuthDialog";
import styles from '../../../../css/auth.pcss.json'

const PageEmailIsTaken: React.FunctionComponent<DialogComponentPropTypes> = ({ switchPage }) => {
  const toIndex = () => switchPage('index')

  return <>
    <BackButton goBack={toIndex} />
    <div className={styles['auth-header']}>
      <h1 style='color: var(--brand-red)'>Ой!</h1>
    </div>
    <p style={{ textAlign: 'center' }}>Указанный email уже зарегистрирован.<br/>Попробуй войти используя другой способ входа.</p>
  </>
}

export default PageEmailIsTaken
